module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_c('div', {
    staticClass: "ui padded grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h2', [_vm._v(" Aktueller Buchstabe: "), _c('b', [_vm._v(_vm._s(_vm.currentLetter))])])]), _vm._v(" "), _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.check
    }
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.entries), function(entry, index) {
    return _c('tr', [_vm._l((['city', 'country', 'river', 'profession']), function(entity) {
      return _c('td', [_vm._v("\n              " + _vm._s(entry[entity].name) + "\n              "), (entry[entity].correct) ? _c('a', {
        attrs: {
          "href": entry[entity].link,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "green checkmark icon"
      })]) : _c('div', [_c('i', {
        staticClass: "red close icon"
      }), _vm._v(" "), _c('a', {
        on: {
          "click": function($event) {
            _vm.showExamples(entity, index)
          }
        }
      }, [_vm._v("Beispiel anzeigen")]), _vm._v(" "), _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.visible.entity === entity && _vm.visible.index === index),
          expression: "visible.entity === entity && visible.index === index"
        }]
      }, _vm._l((entry[entity].examples), function(example) {
        return _c('li', [_c('a', {
          attrs: {
            "href": example.item.value,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(example.itemLabel.value))])])
      }))])])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.points))])], 2)
  }), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.city),
      expression: "newEntry.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Stadt",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.country),
      expression: "newEntry.country"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Land",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.river),
      expression: "newEntry.river"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fluss",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.river)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "river", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEntry.profession),
      expression: "newEntry.profession"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Beruf",
      "pattern": _vm.pattern
    },
    domProps: {
      "value": (_vm.newEntry.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEntry, "profession", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.totalPoints))])])])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "ui active inverted dimmer"
  }, [_c('div', {
    staticClass: "ui loader"
  })]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Stadt")]), _vm._v(" "), _c('th', [_vm._v("Land")]), _vm._v(" "), _c('th', [_vm._v("Fluss")]), _vm._v(" "), _c('th', [_vm._v("Beruf")]), _vm._v(" "), _c('th', [_vm._v("Punkte")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "ui green labeled icon button",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n                Check\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc56619e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 88
// module chunks = 1